module.exports = __webpack_public_path__ + "static/media/guinea-bissau.257a91a4.svg";